<template>
  <div>
    <div v-if="props.showPromptPreview" class="form-title-mini">My Prompt</div>

    <PromptPreview
      ref="promptPreviewRef"
      v-if="props.showPromptPreview"
    ></PromptPreview>

    <div
      v-if="props.showResultSection && result && result.length > 0"
      style="display: flex; flex-direction: column; gap: 20px"
    >
      <GenerateResultSection
        v-for="(resultItem, index) in result"
        :key="resultItem.topic"
        :result="resultItem"
        :index="index"
        :idGenerated="idGenerated"
      ></GenerateResultSection>
      <!-- Only show loading indicator when actually loading AND we have partial results -->
      <GenerateResultSection
        v-if="result.length < 3 && props.showLoading && !props.showErrorSection"
        :isLoading="true"
        :index="result.length"
      ></GenerateResultSection>
    </div>

    <ErrorGenerate @click="retry" v-if="props.showErrorSection"></ErrorGenerate>

    <!-- Only show initial loading when showLoading is true AND we have no results -->
    <GenerateResultSection
      v-if="props.showLoading && (!result || result.length === 0)"
      :isLoading="true"
      :index="0"
    ></GenerateResultSection>
    <!-- <div style="height: 300px;"></div> -->
  </div>
</template>

<script setup>
import { ref, onMounted, defineEmits, watch, defineProps } from "vue";
import GenerateResultSection from "@/components/GenerateResultSection.vue";
import ErrorGenerate from "@/components/ErrorGenerate.vue";
import PromptPreview from "@/components/PromptPreview.vue";
import LocalStorageService from "@/services/localStorageService";
import { useStore } from "vuex";

const props = defineProps({
  showPromptPreview: {
    type: Boolean,
    default: false,
  },
  showLoading: {
    type: Boolean,
    default: false,
  },
  showResultSection: {
    type: Boolean,
    default: false,
  },
  showErrorSection: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();
const result = ref([]);
const idGenerated = ref(Number);
const promptPreviewRef = ref(null);

onMounted(() => {
  updateResult();
});

watch(
  () => store.state.formResult,
  () => {
    updateResult();
  }
);

const updateResult = () => {
  const storedData = store.state.formResult;

  if (storedData && storedData.results) {
    idGenerated.value = storedData.id;
    result.value = storedData.results;
  } else {
    // Clear results when no data or empty results
    result.value = [];
  }

  if (promptPreviewRef.value) {
    promptPreviewRef.value.getPreviewData();
  }
};

const emit = defineEmits(["generate-clicked"]);

const retry = () => {
  let storedData = store.state.formData;

  if (storedData !== null && storedData !== undefined) {
    const formResults = LocalStorageService.getFormResults();
    const formData = LocalStorageService.getFormData();
    if (formResults && formData) {
      store.commit("SET_FORM_RESULTS", formResults);
      store.commit("SET_FORM_DATA", formData);
      storedData = store.state.formData;
    }
  }

  let data = storedData;
  emit("generate-clicked", data);
};
</script>
